import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DialogBase, ProductInfo, ProductPriceInfo, T4CCService } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
    selector: 't4-productprices',
    templateUrl: './T4Prices.html',
  styleUrls: ['./T4Prices.css']
})
export class T4PricesComponent extends DialogBase implements OnInit {
  public prices: ProductPriceInfo[] = [];
  public actualPrices: ProductPriceInfo[] = [];

  @Input() public contextId: string;

  @ViewChild("tblPrices", { static: false }) tblPrices: T4DatatableWidget;
  @ViewChild("tblActualPrices", { static: false }) tblActualPrices: T4DatatableWidget;

  constructor(el: ElementRef, private t4: T4CCService
  ) {
    super("Order");
  }

    async ngOnInit() {
      this.t4.GetProductPrices(this.contextId).then(x => this.prices = x);
      this.t4.GetActualProductPrices(this.contextId).then(x => this.actualPrices = x);
    }


  public addPrice(item: ProductPriceInfo) {
    let prod = new ProductPriceInfo();
    prod.ContextId = this.contextId;
    prod.Product = item.Product;
    prod.ProductId = item.Product.Id;
    this.prices.push(prod);
    
    this.tblPrices.update();
    this.tblActualPrices.update();
  }

  public addProductPrice() {
    let prod = new ProductPriceInfo();
    prod.ContextId = this.contextId;
    this.prices.push(prod);

    this.tblPrices.update();
    this.tblActualPrices.update();
  }

  public async save() {
    if (this.prices != null && this.prices.length > 0) {
      await this.t4.UpdateProductPrice(this.contextId, this.prices).then(x => this.prices = x);

      this.tblPrices.update();
      this.tblActualPrices.update();
      this.UI.alert("Turbo.Order.ProductPrices.Save.titleSuccess", "Saved!", "Turbo.Order.ProductPrices.Save.msgSuccess", "The product prices have been saved.");
    }    
  }

  public async removeObject(item: ProductPriceInfo) {
    if (item.Id) {
      var x = await this.UI.confirm("Turbo.Order.CustomerProductPrices.headConfirmDeletion", "Remove product price", "Turbo.Order.CustomerProductPrices.msgDeletion", 'Are you sure that you want to remove this product price?');
      if (x) {
        var ret = await this.t4.RemoveProductPrice(this.contextId, item.Id).then(x => this.prices = x);
        if (ret) {
          this.tblPrices.update();
          this.tblActualPrices.update();

          this.UI.alert("Turbo.Order.ProductPrices.Remove.titleSuccess", "Deleted!", "Turbo.Order.ProductPrices.Remove.msgSuccess", "The product price have been deleted.");
        }
      }      
    }
    else {
      this.prices = this.prices.filter(p => p.ProductId != item.ProductId);
      this.tblPrices.update();
      this.tblActualPrices.update();

      this.UI.alert("Turbo.Order.ProductPrices.Remove.titleSuccess", "Deleted!", "Turbo.Order.ProductPrices.Remove.msgSuccess", "The product price have been deleted.");
    }    
  }
}
